import React from "react";

import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  ActionButton,
  ActionButtonContainer,
} from "components/AgGrid/ActionButton";
import { ContextMenuPopoverButton } from "components/Button/MultiButton";

import { useIsMobile } from "hooks";

export interface AgGridActionButton {
  onClick: () => void;
  title: string;
  dataTour?: string;
  icon?: IconDefinition;
  isDisabled?: boolean;
  hide?: boolean;
}

interface AgGridActionButtonsProps {
  actions: AgGridActionButton[];
}

export function AgGridActionButtons({ actions }: AgGridActionButtonsProps) {
  const isMobile = useIsMobile();
  if (!actions || !actions.length) {
    return null;
  }

  const shownActions = actions.filter(action => !action.hide);

  if (isMobile) {
    return (
      <ActionButtonContainer>
        <ContextMenuPopoverButton buttons={shownActions} label="" />
      </ActionButtonContainer>
    );
  } else {
    return (
      <ActionButtonContainer>
        {shownActions.map(action => (
          <ActionButton
            data-tour={action.dataTour}
            type="button"
            onClick={action.onClick}
            disabled={action.isDisabled}
            key={action.title}
          >
            {action.icon && <FontAwesomeIcon icon={action.icon} />}
            {action.title}
          </ActionButton>
        ))}
      </ActionButtonContainer>
    );
  }
}
